import { page, type FeatureRoutes } from "@/app/feature";

// /privacy, /terms and /support are static pages built from docs/legal (plugin.ts) and served by Caddy, for the
// stores and the signed-out. Inside the app the same texts open at /legal/:doc (LegalPage), a detail screen
// whose back returns to Settings.
export const routes: FeatureRoutes = {
  shell: [{ path: "legal/:doc", lazy: page(() => import("./LegalPage")) }],
};
